let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7lvtF")).then(() => parcelRequire('7C5UV'));